module.exports = __webpack_public_path__ + "img/background.3fa0ddb.svg";